const semanticClassNames = {
  root: 'collapsible-text',
  text: 'collapsible-text__text',
  button: 'collapsible-text__button',
} as const;

export default semanticClassNames;
